import { useRootStore } from '@nandosaus/state-management';
import { Box, Flex } from '@components/grid';
import { P } from '@components/typography';
import { Link } from '@components/link';
import { useEffect } from 'react';
import PropTypes from 'prop-types';
import { ANALYTICS_EVENTS } from '@nandosaus/constants';
import { analytics } from '../../analytics';

export const GeneralAllergenPDFLink = ({ centeredText, mt }) => {
  const { MenuStore } = useRootStore();

  const { allergenPDF, loading, fetchAllergenPDF } = MenuStore;

  useEffect(() => {
    fetchAllergenPDF();
  }, [fetchAllergenPDF]);

  if (!allergenPDF?.url || loading) {
    return null;
  }

  return (
    <Flex flexDirection="row" mt={mt}>
      <Box width="100%">
        <P variant={2} textAlign={centeredText ? 'center' : undefined}>
          <Link
            href={allergenPDF.url}
            target="_blank"
            variant="text-link"
            onClick={() => analytics.track(ANALYTICS_EVENTS.ALLERGEN_DOCUMENT_VIEWED)}
            textDecoration="underline !important"
          >
            Nando’s menu dietary and allergen information (PDF)
          </Link>
        </P>
      </Box>
    </Flex>
  );
};

GeneralAllergenPDFLink.propTypes = {
  centeredText: PropTypes.bool,
  mt: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
};

GeneralAllergenPDFLink.defaultProps = {
  centeredText: false,
  mt: 1,
};
